import React from 'react'

import { useTranslation } from 'react-i18next'

import { Link, useLocation } from 'react-router-dom'

// Your shadcn breadcrumb components
import { HomeIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

import { paths } from '@/config/paths'

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'

// Or whatever icon library you use

export function AppBreadcrumb() {
  const { t, i18n } = useTranslation(['common'])
  const location = useLocation()
  const isRTL = i18n.dir() === 'rtl'

  const pathnames = location.pathname.split('/').filter(Boolean)

  return (
    <Breadcrumb aria-label='Breadcrumb' className='hidden sm:flex'>
      <BreadcrumbList className='flex items-center'>
        {/* Home Link */}
        <BreadcrumbLink asChild>
          <Link
            to={paths.dashboard.root.getHref()}
            className='flex cursor-pointer items-center gap-1 text-gray-700 hover:text-gray-900'
          >
            <HomeIcon size={16} aria-hidden='true' />
            <span className='sr-only'>{t('common:breadcrumb.dashboard', 'Dashboard')}</span>
            <span className={cn('hidden md:inline', isRTL ? 'mr-1' : 'ml-1')}>
              {t('common:breadcrumb.dashboard', 'Dashboard')}
            </span>
          </Link>
        </BreadcrumbLink>

        {/* Only show separator and other crumbs if not at root */}
        {pathnames.length > 0 && (
          <>
            <BreadcrumbSeparator />

            {pathnames.map((segment, index) => {
              const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`
              const isLast = index === pathnames.length - 1
              const name = segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ')

              return (
                <React.Fragment key={routeTo}>
                  {!isLast ? (
                    <>
                      <BreadcrumbItem className='flex items-center'>
                        <BreadcrumbLink asChild>
                          <Link to={routeTo} className='text-gray-600 hover:text-gray-900'>
                            {name}
                          </Link>
                        </BreadcrumbLink>
                      </BreadcrumbItem>
                      <BreadcrumbSeparator />
                    </>
                  ) : (
                    <BreadcrumbItem>
                      <BreadcrumbPage className='flex items-center' aria-current='page'>
                        {name}
                      </BreadcrumbPage>
                    </BreadcrumbItem>
                  )}
                </React.Fragment>
              )
            })}
          </>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
